<app-page-header title="Conta" active_item="Informações"></app-page-header>
<h5>Informações da conta</h5>
<div class="row" id="user-profile">
  <div class="col-lg-12">
    <div class="card rounded-10 shadow">
      <div class="card-body">
          <div class="row">
            <div class="col">
                <div class="user-wrap">
                  <div class="table-responsive ">
                    <table class="table row table-borderless bg-transparent">
                      <tbody class="col">
                      <tr>
                        <td><p class="fs-17"><strong>ID da conta: </strong> {{account.id}}</p></td>
                      </tr>
                      </tbody>
                    </table>
                </div>
            </div>
          </div>
      </div>
      <div class="border-top">
        <div class="wideget-user-tab">
          <div class="tab-menu-heading">
            <div class="tabs-menu1">
              <ul ngbNav #nav="ngbNav" [activeId]="selected">
                <li [ngbNavItem]="1" *ngIf="this.account.personType == 0">
                  <a ngbNavLink>Empresa</a>
                  <ng-template ngbNavContent>
                    <div class="card">
                      <div class="card-body">
                        <div class="tab-pane active show" id="tab-51">
                          <div id="profile-log-switch-1">
                            <div class="media-heading">
                              <td><p class="fs-17 text-uppercase"><strong>Empresa</strong></p></td>
                            </div>
                            <div class="table-responsive ">
                              <table class="table row table-borderless bg-transparent">
                                <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td><span><strong>CNPJ: </strong> {{account.company.cnpj| mask:'CPF_CNPJ'}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>Razão Social: </strong> {{account.company.razaoSocial}}</span></td>
                                </tr>
                                </tbody>
                                <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td><span><strong>E-mail: </strong> {{account.company.email}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>Telefone: </strong> {{account.company.phone | mask:'(00) 00000-0000'}}</span></td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="2">
                  <a ngbNavLink>Endereço</a>
                  <ng-template ngbNavContent>
                    <div class="card">
                      <div class="card-body">
                        <div class="tab-pane active show" id="tab-52">
                          <div id="profile-log-switch-2">
                            <div class="media-heading">
                              <td><p class="fs-17 text-uppercase"><strong>Endereço</strong></p></td>
                            </div>
                            <div class="table-responsive ">
                              <table class="table row table-borderless bg-transparent">
                                <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td><span><strong>Logradouro :</strong> {{account.adress.logradouro}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>Bairro :</strong> {{account.adress.bairro}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>Cidade :</strong> {{account.adress.cidade}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>Complemento :</strong> {{account.adress.complemento}}</span></td>
                                </tr>
                                </tbody>
                                <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td><span><strong>Número :</strong> {{account.adress.numero}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>CEP :</strong> {{account.adress.cep | mask:'00000-000'}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>Estado :</strong> {{account.adress.estado}}</span></td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="3">
                  <a ngbNavLink>Responsável</a>
                  <ng-template ngbNavContent>
                    <div class="card">
                      <div class="card-body">
                        <div class="tab-pane" id="tab-61">
                          <div id="profile-log-switch-3">
                            <div class="media-heading">
                              <td><p class="fs-17 text-uppercase"><strong>Responsável</strong></p></td>
                            </div>
                            <div class="table-responsive ">
                              <table class="table row table-borderless bg-transparent">
                                <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td><span><strong>CPF :</strong> {{account.sponsor.cpf | mask: 'CPF_CNPJ'}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>E-mail :</strong> {{account.sponsor.email}}</span></td>
                                </tr>
                                </tbody>
                                <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td><span><strong>Nome :</strong> {{account.sponsor.name}}</span></td>
                                </tr>
                                <tr>
                                  <td><span><strong>Telefone :</strong> {{account.sponsor.phone | mask:'(00) 00000-0000'}}</span></td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="4">
                  <a ngbNavLink>API</a>
                  <ng-template ngbNavContent>
                    <div class="card">
                      <div class="card-body">
                        <div class="tab-pane" id="tab-62">
                          <div id="profile-log-switch-4">
                            <div class="media-heading">
                              <td><p class="fs-17 text-uppercase"><strong>Tokens de acesso API</strong></p></td>
                            </div>
                            <div class="table-responsive ">
                              <table class="table row table-borderless bg-transparent">
                                <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td><span><strong>Client-Id :</strong> {{account.clientId}}</span></td>
                                </tr>
                                </tbody>
                                <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td><span><strong>Secret :</strong> {{account.secret}}</span></td>
                                </tr>
                                </tbody>
                              </table>
                            </div>                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
                <li [ngbNavItem]="5">
                  <a ngbNavLink>Taxas</a>
                  <ng-template ngbNavContent>
                    <div class="card">
                      <div class="card-body">
                        <div class="tab-pane" id="tab-72">
                          <div id="profile-log-switch-5">
                            <div class="media-heading">
                              <td><p class="fs-17 text-uppercase"><strong>Configurações de Taxas</strong></p></td>
                            </div>
                            <div class="table-responsive ">
                              <table class="table row table-borderless bg-transparent">
                                <tbody class="col-lg-12 col-xl-4 p-0">
                                  <tr>
                                    <td><h5>Depósito</h5></td>
                                  </tr>
                                  <tr>
                                    <td><span><strong>Aplicativo: </strong> {{accountTaxes.applicationDepositTaxPercent | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}% + R$ {{accountTaxes.applicationDepositTaxValue | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</span></td>
                                    <td><span><strong>API: </strong> {{accountTaxes.apiDepositTaxPercent | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}% + R$ {{accountTaxes.apiDepositTaxValue | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</span></td>
                                  </tr>
                                </tbody>
                                <tbody class="col-lg-12 col-xl-4 p-0">
                                  <tr>
                                    <td><h5>Saque</h5></td>
                                  </tr>
                                  <tr>
                                    <td><span><strong>Aplicativo: </strong> {{accountTaxes.applicationWithDrawTaxPercent | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}% + R$ {{accountTaxes.applicationWithDrawTaxValue | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</span></td>
                                    <td><span><strong>API: </strong> {{accountTaxes.apiWithDrawTaxPercent | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}% + R$ {{accountTaxes.apiWithDrawTaxValue | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</span></td>
                                  </tr>
                                </tbody>
                                <tbody class="col-lg-12 col-xl-4 p-0">
                                  <tr>
                                    <td><h5>Criptoativos</h5></td>
                                  </tr>
                                  <tr>
                                    <td><span><strong>Aplicativo: </strong> {{accountTaxes.applicationCriptoTaxPercent | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}% + R$ {{accountTaxes.applicationCriptoTaxValue | mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</span></td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div [ngbNavOutlet]="nav"></div>
  </div><!-- COL-END -->
</div>
<!-- ROW-1 CLOSED -->
<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); isLoaded = true;"></button>
  </div>
  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage.length > 0" class="text-danger">
        {{errorMessage}}</p>
    </div>
    <div class="form-group mb-3">
      <input type="text" class="form-control" id="authToken" placeholder="Token" [(ngModel)]="validationCode" (keyup.enter)="validateTotp()">
    </div>
  </div>
  <div class="modal-footer text-center">
    <button type="submit" class="btn btn-lg btn-primary btn-pill mx-auto d-block" (click)="validateTotp()">
      VALIDAR
    </button>
  </div>
</ng-template>
